/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ContractStatus = zod.enum(['pending', 'active', 'expired']);

export type ContractStatus = zod.input<typeof ContractStatus>;
export type ContractStatusOutput = zod.output<typeof ContractStatus>;
